import * as React from "react";
import { CourseContext } from "src/providers/Course";

const useCourse = () => {
  return React.useContext(CourseContext);
};

export default useCourse;
